<template>
  <div
    slot="header"
    class="designer-sidebar__actions"
  >
    <span>Add/Edit Row Designer</span>
    <div class="search_input--box">
      <b-form-input
        class="search_input"
        :value="searchValue"
        placeholder="Search by sections"
        @input="setSearchValue"
      />
      <b-button
        v-if="searchValue.length"
        variant="outlined"
        size="sm"
        @click="resetSearchValue"
      >
        <font-awesome-icon :icon="['fas', 'close']" />
      </b-button>
    </div>
    <div class="actions__wrapper">
      <b-button
        size="sm"
        @click="onAddClick"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
        Add section
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        @click="onSortClick"
      >
        <font-awesome-icon :icon="['fas', 'sort']" />
        Sort sections
      </b-button>
      <b-button
        variant="info"
        size="sm"
        @click="onSaveClick"
      >
        <template v-if="isLoading">
          <b-spinner
            type="grow"
            style="width: 1.5em; height: 1.5em"
          />
          Loading...
        </template>

        <template v-else>
          <font-awesome-icon :icon="['fas', 'check']" />
          Save changes
        </template>
      </b-button>
    </div>
    <add-new-designer-section-modal v-if="isModalOpened" />
    <sections-reorder-layout v-if="isSectionsReorderOpened" />
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import AddNewDesignerSectionModal
  from '@/modules/DataManagement/views/designer/components/modals/AddEditDesignerSectionModal.vue';
import SectionsReorderLayout from '@/modules/DataManagement/views/designer/components/SectionsReorderLayout.vue';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');

export default {
  name: 'DesignerActions',
  components: {
    SectionsReorderLayout,
    AddNewDesignerSectionModal,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...designerMapState({
      isSectionsReorderOpened: state => state.isSectionsReorderModalOpened,
      isModalOpened: state => state.addEditSectionModal.isOpen,
      searchValue: state => state.searchValue,
      isSettingsWasChanged: state => state.isSettingsWasChanged,
    }),
  },
  methods: {
    ...designerMapActions([
      'setAddNewSectionModalState',
      'setSectionReorderModalState',
      'setSearchValue',
      'saveDesignerTabState',
    ]),
    async onAddClick() {
      await this.setSearchValue('');
      this.setAddNewSectionModalState({
        isOpen: true,
        isEditMode: false,
      });
    },
    async onSaveClick() {
      this.isLoading = true;
      try {
        await this.saveDesignerTabState({uuid: this.$route.params.tableUuid, isSubmit: false});
        this.$toasted.success('Changes was saved successfully', {duration: TOASTER_DURATION});
      } catch (e) {
        this.$toasted.success('Something went wrong', {duration: TOASTER_DURATION});
      } finally {
        this.isLoading = false;
      }
    },
    onSortClick() {
      this.setSectionReorderModalState(true);
    },
    resetSearchValue() {
      this.setSearchValue('');
    },
  },
};
</script>

<style scoped lang="scss">
.designer-sidebar__actions,
.actions__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.designer-sidebar__actions {
  padding: 10px;
  border-bottom: 1px solid #eee;
  gap: 10px;
}

.actions__wrapper {
  gap: 5px;
  flex-wrap: nowrap;
}

.search_input--box {
  position: relative;

  & .btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-10%, -50%);
  }
}

.search_input {
  width: 20vw;
}
</style>